import { type Styles } from '@mui/styles';
import { type CustomTheme } from '../../../provider/ThemeProvider';
import { dangerColor, greyColor, infoColor, successColor, warningColor, whiteColor } from '../material-dashboard-pro-react';

const badgeStyle: Styles<CustomTheme, any, string> = (theme) => ({
    badge: {
        borderRadius: '12px',
        padding: '5px 12px',
        textTransform: 'uppercase',
        fontSize: '10px',
        fontWeight: '700',
        lineHeight: '1',
        color: whiteColor,
        textAlign: 'center',
        verticalAlign: 'baseline',
        display: 'inline-block',
    },
    primary: {
        backgroundColor: theme?.palette?.primary?.main,
    },
    warning: {
        backgroundColor: warningColor[0],
    },
    danger: {
        backgroundColor: dangerColor[0],
    },
    success: {
        backgroundColor: successColor[0],
    },
    info: {
        backgroundColor: infoColor[0],
    },
    grey: {
        backgroundColor: greyColor[0],
    },
});

export default badgeStyle;
